// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"409bc3e4","722":"9128e639","766":"319d3cca"}[chunkId] + ".chunk.css";
};